import { Modifier, StrictModifiers } from "@popperjs/core/lib/types";
import { ModifierPhases } from "@popperjs/core";

export type DropdownModifiers = 'offset' | 'arrow' | 'sameWidth' | 'computedStyles';
export const dropdownModifiers: Record<DropdownModifiers, Modifier<any, any> | StrictModifiers> = {
  offset:         { name: 'offset', options: { offset: [0, 6] } },
  arrow:          { name: 'arrow', options: { padding: 4 } },
  sameWidth:      {
    name:     'sameWidth',
    enabled:  true,
    phase:    'beforeWrite' as ModifierPhases,
    requires: ['computeStyles'],
    fn:       ({ state }) => {
      state.styles.popper.width = `${state.rects.reference.width}px`;
    },
    effect:   ({ state }) => {
      state.elements.popper.style.width = `${(state.elements.reference as HTMLElement).offsetWidth}px`;
    },
  },
  computedStyles: {
    name:    'computeStyles',
    options: {
      adaptive: false, // true by default
    },
  },
};

export const defaultDropdownModifiers = [
  dropdownModifiers.offset,
  dropdownModifiers.arrow,
  // dropdownModifiers.computedStyles,
];
export const sameWidthDropdownModifiers = [
  dropdownModifiers.offset,
  dropdownModifiers.arrow,
  dropdownModifiers.sameWidth,
  // dropdownModifiers.computedStyles,
];